import { render, staticRenderFns } from "./ShareIcon.vue?vue&type=template&id=17536a37&"
import script from "./ShareIcon.vue?vue&type=script&lang=js&"
export * from "./ShareIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports